module.exports = __webpack_public_path__ + "img/Xingqi_Chen-1-500x500.e6cfa271.png";